<template>
	<div class="item-list-container">
		<p class="title">{{ $t('itemsummarylist.title') }}</p>

		<div class="list-container" v-for="info in comInfos" :key="info.id">
			<div class="title">{{ `${info.buildingName} - ${info.floorName}` }}</div>
			<div class="panel-list-header narrow">
				<div class="panel-filler-icon" />
				<div class="panel-header-item pos" :class="{ mobile: isMobile }">
					{{ isMobile ? $t('itemsummarylist.header_pos_mobile') : $t('itemsummarylist.header_pos') }}
				</div>
				<div class="panel-header-item type">{{ $t('itemsummarylist.header_type') }}</div>
			</div>
			<div
				class="panel-list no-hover narrow"
				v-for="item in info.items"
				:key="item.id"
			>
				<div class="panel-list-item special">
					<div
						class="fireprotection-icon"
						:class="getType(item.inventoryType)"
					></div>
				</div>
				<p class="panel-list-item pos" :class="{ mobile: isMobile }">
					{{ item.positionNumber }}
				</p>
				<div class="panel-list-item type">{{ item.name }}</div>
				<div class="panel-list-item flaw-total" v-if="getFlaws(item)">
					<i class="fas fa-exclamation-triangle"></i>
					{{ `: ${getFlaws(item)}` }}
				</div>
			</div>
			<div
				class="panel-list no-hover narrow"
				v-for="flaw in info.flaws"
				:key="flaw.id"
			>
				<div class="panel-list-item special">
					<div class="fireprotection-icon flaw"></div>
				</div>
				<p class="panel-list-item pos" :class="{ mobile: isMobile }"></p>
				<div class="panel-list-item type">{{ $t('itemsummarylist.label_flaw') }}</div>
				<div class="panel-list-item">
					{{ flaw.name }}
					{{ flaw.description ? ` - ${flaw.description}` : null }}
				</div>
			</div>
		</div>
		<div class="panel-list no-hover" v-if="comInfos.length == 0">
			<p class="panel-list-item">{{ $t('itemsummarylist.no_controlled_items') }}</p>
		</div>
	</div>
</template>

<script>
import iconMixin from '@/mixins/iconMixin.js';
import { mapGetters } from 'vuex';

export default {
	mixins: [iconMixin],
	props: {
		infos: Array
	},
	computed: {
		...mapGetters('appStore', ['isMobile']),
		...mapGetters('roundStore', ['round']),
		comInfos() {
			let list = [];
			this.infos.forEach(info => {
				let itemList = [];
				info.roundHistoryItems.forEach(item => {
					if (item.controlled) {
						itemList.push(item);
					}
				});

				if (itemList.length) {
					itemList.sort((a, b) =>
						a.positionNumber > b.positionNumber
							? 1
							: a.positionNumber === b.positionNumber
								? a.id > b.id
									? 1
									: -1
								: -1
					);
					info.items = itemList;
					list.push(info);
				}
			});

			return list;
		}
	},
	methods: {
		getFlaws(item) {
			let total = 0;
			item.flaws.forEach(flaw => {
				if (item.continueWithoutAdding && !this.round.done && !flaw.done) {
					total++;

					return;
				}

				if (!flaw.created || flaw.created > this.round.created) {
					if (!this.round.done || flaw.created < this.round.done) {
						total++;
					}
				}
			});

			return total;
		}
	}
};
</script>

<style lang="scss" scoped>
@import "@/assets/colors.scss";
.item-list-container {
  margin-top: 1rem;
  p.title {
    font-size: 1.5rem;
  }
}
.panel-list-header.narrow,
.panel-list.narrow {
  margin-right: 0;
  margin-left: 0;
  width: 100%;
}
.list-container {
  &:not(:first-child) {
    margin-top: 0.8rem;
  }
  .title {
    font-size: 1.3rem;
    margin-bottom: 0.8rem;
  }
}
.panel-list-item.special {
  margin-right: 5px;
  max-width: 40px;
  position: relative;
}
.panel-list.narrow {
  .fireprotection-icon {
    top: -3px;
  }
}
.panel-list-item.flaw-total {
  margin-left: auto;
  max-width: 55px;
  i {
    color: $danger;
  }
}
.panel-list-item.type,
.panel-header-item.type {
  max-width: 250px;
}
.panel-list-item.pos,
.panel-header-item.pos {
  max-width: 80px;
  &.mobile {
    max-width: 40px;
  }
}
.fireprotection-icon {
  background-color: white;
  top: -7px;
  width: 30px;
  height: 30px;
  z-index: 2;
  position: absolute;
  background-size: contain;
  print-color-adjust: exact;
}

@media print {
  .item-list-container {
    break-inside: avoid;
  }
  .list-container:not(:first-of-type) {
    break-inside: avoid;
  }
}
</style>
